export default __webpack_public_path__ + "static/media/gatsby.bfef1984.png";